import { CurrenciesState } from './types'

export const initialState: CurrenciesState = {
  currencies: {
    symbols: {},
    localizations: {},
  },
  ready: false,
}
